import { types as t, getParent } from 'mobx-state-tree';

import uiStore from './UIStore';

export const DepartmentTranslation = t.model('DepartmentTranslation', {
  title: t.string,
  language: t.string,
});

export const findTranslationForLanguage = (translations, language) => {
  return (translations ?? []).find((translation) => {
    return translation.language === language;
  });
};

export const findTranslationForCurrentLanguage = (translations) => {
  return findTranslationForLanguage(translations, uiStore.language);
};

export default t
  .model('Department', {
    id: t.identifierNumber,
    translations: t.array(DepartmentTranslation),
  })
  .views((self) => ({
    get translatedName() {
      // Departments are only reachable through Company.departments, so the company
      // two levels up is what supplies the default-language fallback.
      const company = getParent(self, 2);
      const translation =
        findTranslationForCurrentLanguage(self.translations) ||
        findTranslationForLanguage(self.translations, company.defaultLanguage) ||
        self.translations[0];
      return translation ? translation.title : '';
    },
  }));
